import { default as calculationYoWTfTMw8UMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/layers/travel/pages/calculation.vue?macro=true";
import { default as detailfmJi5VLiKYMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/layers/travel/pages/detail.vue?macro=true";
import { default as inquiryxwqD2o9qeEMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue?macro=true";
import { default as _91_91type_93_93CUb9WQBh7JMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue?macro=true";
import { default as offer_45listPtfWD9RBFmMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue?macro=true";
import { default as testingUuYAAYJUmAMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/pages/testing.vue?macro=true";
import { default as thankyoupcJohUXsjEMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue?macro=true";
import { default as upsellqMHFHUB0LFMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/layers/travel/pages/upsell.vue?macro=true";
import { default as zadostEWn1c2FbmYMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thankfVJAQcGXMpMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnaniwtsBfqLg6hMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
import { default as pageXiUXwIBMOhMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45test1pQ6XWFDlmMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepageqRJxFN6iLJMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as articleWEeLQqakSjMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patterns1fdrrXRbuVMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tagHux5pVRQEFMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autorFCVI0KedLMMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as categoryeYCTwTNo9iMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as sectionK6aQSoxcL1Meta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articlesYhrGb0OmOaMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as category6mwkVWAtekMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articleCEMivxLj9OMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as sectionJvOYwcyCklMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as contactSC2UzCW6jYMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45terminationB93luoEawJMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as calculationOeDU4swWR7Meta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation?macro=true";
import { default as thank_45youPCQfDjFi0FMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you?macro=true";
import { default as detailkp2rnev0pDMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail?macro=true";
import { default as inquiryhFoaELP7mtMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry?macro=true";
import { default as offer_45list5DgfYFUr8TMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list?macro=true";
import { default as calculationLCw84LG5alMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation?macro=true";
import { default as thank_45youW8D2v0IyzfMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you?macro=true";
import { default as inquiryaHeZJa9UWQMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry?macro=true";
import { default as offer_45listHIYC2x9o72Meta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list?macro=true";
import { default as detail9mYw3Be9aEMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail?macro=true";
import { default as offer0OHeaqjU7pMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer?macro=true";
import { default as inquiryMsuYfVj54SMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry?macro=true";
import { default as thank_45youwV9ouWDGJAMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you?macro=true";
import { default as calculationGg9yqbswN5Meta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation?macro=true";
import { default as offer_45listsAWo5krtmbMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list?macro=true";
import { default as thank_45youL0r9FbPndAMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you?macro=true";
import { default as inquiry_45onlinevduWZM0nL2Meta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online?macro=true";
import { default as detailFOw95DfpnCMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/energo/pages/detail?macro=true";
import { default as inquiry_45phonea621nsPOgUMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone?macro=true";
import { default as inquiry_45custom_45offerr4cpTk8friMeta } from "/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer?macro=true";
export default [
  {
    name: "calculation",
    path: "/cestovni-pojisteni/zadani/:leadId?",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/layers/travel/pages/calculation.vue")
  },
  {
    name: "detail",
    path: "/cestovni-pojisteni/:leadId?/detail/:offerId?",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/layers/travel/pages/detail.vue")
  },
  {
    name: "inquiry",
    path: "/cestovni-pojisteni/sjednani/:leadId?",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/layers/travel/pages/inquiry.vue")
  },
  {
    name: "kurzy-company-type",
    path: "/kurzy/:company?/:type?",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/pages/kurzy/[[company]]/[[type]].vue")
  },
  {
    name: "offer-list",
    path: "/cestovni-pojisteni/nabidka/:leadId?",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/layers/travel/pages/offer-list.vue")
  },
  {
    name: "testing",
    path: "/testing",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/pages/testing.vue")
  },
  {
    name: "thankyou",
    path: "/cestovni-pojisteni/dekujeme/:leadId?",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/layers/travel/pages/thankyou.vue")
  },
  {
    name: "upsell",
    path: "/cestovni-pojisteni/upsell/:leadId?",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/layers/travel/pages/upsell.vue")
  },
  {
    name: zadostEWn1c2FbmYMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/zadost",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thankfVJAQcGXMpMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnaniwtsBfqLg6hMeta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  },
  {
    name: pageXiUXwIBMOhMeta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45test1pQ6XWFDlmMeta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepageqRJxFN6iLJMeta?.name,
    path: "/clanky",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: articleWEeLQqakSjMeta?.name,
    path: "/clanky/:article(.*)*",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patterns1fdrrXRbuVMeta?.name,
    path: "/clanky/vzory-dokumentu",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tagHux5pVRQEFMeta?.name,
    path: "/clanky/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autorFCVI0KedLMMeta?.name,
    path: "/clanky/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: categoryeYCTwTNo9iMeta?.name,
    path: "/clanky/:category(kategorie)",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: sectionK6aQSoxcL1Meta?.name,
    path: "/clanky/:category(kategorie)/:section(pojisteni|hypoteky|pujcky|energie|mobilni-tarify|osobni-finance)",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articlesYhrGb0OmOaMeta?.name,
    path: "/clanky/all-articles",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: pageXiUXwIBMOhMeta?.name,
    path: "/slovnik-pojmu",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: category6mwkVWAtekMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articleCEMivxLj9OMeta?.name,
    path: "/slovnik-pojmu/:category(elektrina|hypoteky|penzijni-sporeni|plyn|povinne-ruceni|uvery|pujcky)/:id(.*)*",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: sectionJvOYwcyCklMeta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: sectionJvOYwcyCklMeta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: contactSC2UzCW6jYMeta?.name,
    path: "/kontakt",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45terminationB93luoEawJMeta?.name,
    path: "/zruseni-povinneho-ruceni-zmena-pojistovny",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: calculationOeDU4swWR7Meta?.name,
    path: "/internet/kalkulace",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/calculation")
  },
  {
    name: thank_45youPCQfDjFi0FMeta?.name,
    path: "/internet/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/thank-you")
  },
  {
    name: detailkp2rnev0pDMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/detail")
  },
  {
    name: inquiryhFoaELP7mtMeta?.name,
    path: "/internet/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/inquiry")
  },
  {
    name: offer_45list5DgfYFUr8TMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/internet/offer-list")
  },
  {
    name: calculationLCw84LG5alMeta?.name,
    path: "/mobilni-tarify/kalkulace",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/calculation")
  },
  {
    name: thank_45youW8D2v0IyzfMeta?.name,
    path: "/mobilni-tarify/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/thank-you")
  },
  {
    name: inquiryaHeZJa9UWQMeta?.name,
    path: "/mobilni-tarify/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/inquiry")
  },
  {
    name: offer_45listHIYC2x9o72Meta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/offer-list")
  },
  {
    name: detail9mYw3Be9aEMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/mobile/detail")
  },
  {
    name: offer0OHeaqjU7pMeta?.name,
    path: "/balicky-sluzeb/priklad-nabidky",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/offer")
  },
  {
    name: inquiryMsuYfVj54SMeta?.name,
    path: "/balicky-sluzeb/sjednani-nabidky",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/inquiry")
  },
  {
    name: thank_45youwV9ouWDGJAMeta?.name,
    path: "/balicky-sluzeb/potvrzeni-objednavky",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/telco/pages/packages/thank-you")
  },
  {
    name: calculationGg9yqbswN5Meta?.name,
    path: "/energie/kalkulace-:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/energo/pages/calculation")
  },
  {
    name: offer_45listsAWo5krtmbMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/energo/pages/offer-list")
  },
  {
    name: thank_45youL0r9FbPndAMeta?.name,
    path: "/energie/prehled-vaseho-pozadavku/:leadId?",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/energo/pages/thank-you")
  },
  {
    name: inquiry_45onlinevduWZM0nL2Meta?.name,
    path: "/energie/sjednani-online/:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-online")
  },
  {
    name: detailFOw95DfpnCMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId/detail/:tariffId",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/energo/pages/detail")
  },
  {
    name: inquiry_45phonea621nsPOgUMeta?.name,
    path: "/energie/sjednani-po-telefonu/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-phone")
  },
  {
    name: inquiry_45custom_45offerr4cpTk8friMeta?.name,
    path: "/energie/nabidka-na-miru",
    component: () => import("/codebuild/output/src1451940903/src/nuxt-porovnej24/.srovnejto/energo/pages/inquiry-custom-offer")
  }
]